//@flow

export function createCanvas(width: number, height: number) {
  if ('OffscreenCanvas' in window) {
    return new window.OffscreenCanvas(width, height);
  } else {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
  }
}
